import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SiteModeContext = createContext(null);

export const SiteModeProvider = ({ children }) => {
  const [state, setState] = useState({ loading: true, mode: 'founding', isTester: false, isAdmin: false, testerUsername: null });

  const refresh = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/site/mode`, { withCredentials: true });
      setState({ loading: false, mode: data.mode, isTester: data.is_tester, isAdmin: data.is_admin, testerUsername: data.tester_username });
    } catch {
      setState((s) => ({ ...s, loading: false }));
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return <SiteModeContext.Provider value={{ ...state, refresh }}>{children}</SiteModeContext.Provider>;
};

export const useSiteMode = () => useContext(SiteModeContext);
